// DEPRECATED. NOW USING Swagger.apis.forms.proceedOnFieldActions

export type IFormVariablesCalculate = (formId: string, actionBaseUrl: string) => void;

export function formVariablesCalculate(formId: string, actionBaseUrl: string): void {
  // By default form variables are calculated by posting current data
  const $form = $(`#${formId}`);
  const suffix = $form.data('suffix');
  let serializedFormData = $form.serialize();
  // If you want to overwrite this data, define window.DexeroCoreApp.onBeforeFormVariablesCalculate <-- Must return a promise with serialized form data
  function interceptFormVariablesCalculate() {
    const dfd = new ($ as any).Deferred();
    if (typeof window.DexeroCoreApp.onBeforeFormVariablesCalculate === 'function') {
      window.DexeroCoreApp.onBeforeFormVariablesCalculate(serializedFormData).done(
        (responseData: string) => {
          serializedFormData = responseData;
          dfd.resolve(serializedFormData);
        }
      );
    } else {
      dfd.resolve(serializedFormData);
    }
    return dfd.promise();
  }

  interceptFormVariablesCalculate().done((responseData: string) => {
    ($ as any)
      .post(`${actionBaseUrl}ajax_form_variable_calculate`, responseData, 'json')
      .done((postResponseData: string) => {
        const data = JSON.parse(postResponseData);
        $.each(data, (key: string, value) => {
          if (key.startsWith('form_var_')) {
            $(`.${key}`).each((_, elm) => {
              $(elm).html(value);
            });
          }
        });
        $(document).trigger(`onFormVariableCalculate${suffix}`, [data]);
      });
  });
}
